import { normalizeFileId } from '@/common/hooks/useImage';
import { CHAT_MEDIA_RETURN_TYPE } from '../constants/chatRequests.constants';

export const CHAT_MEDIA_GALLERY_TYPE = {
	IMAGE: 'image',
	VIDEO: 'video',
};

const getMessageMediaId = (media) => normalizeFileId(media?._id ?? media);

export const getMessageGalleryMedia = (msg) => {
	const isImage = msg?.response_format === CHAT_MEDIA_RETURN_TYPE.IMAGE;
	const isVideo =
		msg?.response_format === CHAT_MEDIA_RETURN_TYPE.VIDEO || Boolean(msg?.video);

	if (isImage) {
		const mediaId = getMessageMediaId(msg.image);

		if (mediaId) {
			return {
				url: mediaId,
				caption: msg.content,
				type: CHAT_MEDIA_GALLERY_TYPE.IMAGE,
			};
		}
	}

	if (isVideo) {
		const mediaId =
			getMessageMediaId(msg.video) || getMessageMediaId(msg.image);

		if (mediaId) {
			return {
				url: mediaId,
				caption: msg.content,
				type: CHAT_MEDIA_GALLERY_TYPE.VIDEO,
			};
		}
	}

	return null;
};

export const getConversationMediaFromMessages = (messages) => {
	return messages.map(getMessageGalleryMedia).filter(Boolean);
};
